module.exports = __webpack_public_path__ + "images/c3bcc458cadaf324741b017cf93420b9.png";